import {VuesticPlugin, useGlobalConfig} from 'vuestic-ui';
import {createApp} from 'vue';
import {createGtm} from 'vue-gtm';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuesticGlobalConfig from './services/vuestic-ui/global-config';
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import '@/static/css/srcoll.scss';
import '@/static/css/material_icons.scss';
import '@/static/css/material_icons_400.scss';
import '@/static/css/material_incons_family.scss';
import api from "./api/index";
import i18n from './plugins/i18n';
import Antd from './plugins/antd';
import utils from './pages/admin/utils/utils';
import {QuillEditor} from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import SharedFunctionPlugin from './plugins/sharedFunctionPlugin';
import 'ant-design-vue/dist/antd.css';

// Vue 应用初始化
const app = createApp(App);
app.config.globalProperties.$api = api;
app.config.globalProperties.$utils = utils;

app.use(store);
app.use(router);
app.use(SharedFunctionPlugin);

const gtmId = process.env.VUE_APP_GTM_KEY;
if (process.env.VUE_APP_GTM_ENABLED === 'true' && gtmId) {
  const gtmConfig = {
    id: gtmId,
    debug: false,
    vueRouter: router,
  };
  app.use(createGtm(gtmConfig));
}

app.use(i18n);
app.use(VuesticPlugin, vuesticGlobalConfig);
app.use(VXETable);
app.use(Antd);
app.component('QuillEditor', QuillEditor);

app.mount('#app');
